exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TooltipWrap:hover .Tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translate(-50%, -10px) scale(1); }\n  .TooltipWrap:hover .Tooltip.Tooltip--Bottom {\n    transform: translate(-50%, 10px) scale(1); }\n", ""]);

// exports
